// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/hooks/useEstoquePosicao.ts
// ════════════════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { estoqueService } from '../services/estoqueService';
import { apiClient } from '@/lib/apiClient';

// ── Resumo do estoque (KPIs do dashboard) ─────────────────────────────────

export interface EstoqueResumo {
  totalProdutos:     number;
  produtosEmAlerta:  number;
  valorTotalEstoque: number;
  produtosVencendo:  number;
}

export const useEstoqueResumo = () =>
  useQuery({
    queryKey: ['estoque-resumo'],
    queryFn:  async () => {
      const { data } = await apiClient.get<EstoqueResumo>('/api/estoque/resumo');
      return data;
    },
  });

interface UsePosicaoParams {
  pagina?: number;
  tamanhoPagina?: number;
  busca?: string;
  localId?: number;
  situacao?: string;
}

export const useEstoquePosicao = ({
  pagina = 1,
  tamanhoPagina = 20,
  busca,
  localId = 0,
  situacao,
}: UsePosicaoParams = {}) =>
  useQuery({
    queryKey: ['estoque-posicao', pagina, tamanhoPagina, busca, localId, situacao],
    queryFn:  () => estoqueService.getPosicao(pagina, tamanhoPagina, busca, localId, situacao),
  });

export const useEstoqueReposicao = (filtros: { localId?: number; busca?: string; grupoId?: number } = {}) =>
  useQuery({
    queryKey: ['estoque-reposicao', filtros],
    queryFn:  () => estoqueService.getReposicaoFiltrada(filtros),
  });
